import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Popconfirm } from "antd";
import _ from "lodash";
import UserTypes from "components/auth/user-types";
import FunctionalButton from "components/common/FunctionalButton";
import DownloadContactsButton from "components/menu/reporting/download-contacts-report";
import DownloadJobsChargeRateButton from "components/menu/reporting/download-jobs-charge-rate-report";
import DownloadMerchandiserPayRateButton from "components/menu/reporting/download-merchandiser-pay-rate";

import {
    closeCustomModal,
    openCustomModal
} from "components/custom/modals";

// import NewDraftModal from "components/schedule/DraftSchedules/new-draft-modal";
const NewDraftModal = React.lazy(() =>
    import("components/schedule/DraftSchedules/new-draft-modal"));

class Buttons extends React.Component {
    constructor(props) {
        super(props);

        this.openDraftModal = this.openDraftModal.bind(this);
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.showDetailsButtons !== this.props.showDetailsButtons) {
            return true;
        } else if (!_.isEqual(nextProps.availableExport, this.props.availableExport)) {
            return true;
        }
        return false;
    }

    isExportAvailable() {
        const { availableExport } = this.props;
        // eslint-disable-next-line no-restricted-syntax
        for (const id in availableExport.idObj) {
            if (availableExport.idObj[id] === false) {
                return false;
            }
        }
        return true;
    }

    openDraftModal () {
        const modalObj = {
            id: "create-new-draft",
            modalSettings: {
                size: "lg"
            },
            header: "Create Draft Schedule",
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <NewDraftModal
                        handleHide={() => this.props.closeCustomModal(modalObj)}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    }

    render() {
        const {
            handleClickDetailsBtn,
            handleClickDelete,
            handleClickInactivate,
            handleClickExport,
            auth,
            availableExport
        } = this.props;

        const isSupervisor = auth.user.role.includes(UserTypes.supervisor);

        const isExportAvailable = this.isExportAvailable();

        const draftsCount = Object.keys(availableExport.idObj).length;
        const serviceCount = availableExport.serviceCount;

        return (
            <div className="d-flex flex-wrap justify-content-between mt-3">
                <div>

                    <FunctionalButton
                        variant="success"
                        value="Details"
                        onClick={handleClickDetailsBtn}
                        disabled={!this.props.showDetailsButtons}
                    />

                    {!this.props.showNewDraftButton ||
                    <FunctionalButton
                        variant="secondary ml-2"
                        value="New Draft Schedule"
                        onClick={this.openDraftModal}
                    />
                    }

                    <DownloadContactsButton
                        className="btn btn-success ml-2"
                        title="Contacts Report"
                    />
                    <DownloadJobsChargeRateButton
                        className="btn btn-success ml-2"
                        title="Job Charge Rate"
                    />
                    <DownloadMerchandiserPayRateButton
                        className="btn btn-success ml-2"
                        title="Merchandiser Pay Rate"
                    />
                </div>

                <div>

                    {this.props.showDetailsButtons && !isSupervisor ?
                        <React.Fragment>

                            <Popconfirm
                                title={
                                    <div>
                                        You are about to <b className="text-danger">DELETE {draftsCount} draft schedules</b> with total <b className="text-danger">{serviceCount} services.</b>
                                        <br/>
                                        <div className="text-right">Continue?</div>
                                    </div>
                                }
                                onConfirm={handleClickDelete}
                                placement="top"
                                okText="Yes"
                                cancelText="Cancel"
                            >
                                <FunctionalButton
                                    variant="danger ml-2"
                                    value="Delete Selected"
                                />
                            </Popconfirm>

                            <Popconfirm
                                title={
                                    <div>
                                        You are about to <b className="text-danger">INACTIVATE {draftsCount} draft schedules</b> with total <b className="text-danger">{serviceCount} services.</b>
                                        <br/>
                                        <div className="text-right">Continue?</div>
                                    </div>
                                }
                                onConfirm={handleClickInactivate}
                                placement="topLeft"
                                okText="Yes"
                                cancelText="Cancel"
                            >
                                <FunctionalButton
                                    variant="warning ml-2"
                                    value="Inactivate Selected"
                                />
                            </Popconfirm>

                            <Popconfirm
                                title={
                                    <div>
                                        You are about to <b className="text-danger">EXPORT {draftsCount} draft schedules</b> with total <b className="text-danger">{serviceCount} services.</b>
                                        <br/>
                                        <div className="text-right">Continue?</div>
                                    </div>
                                }
                                onConfirm={handleClickExport}
                                placement="topLeft"
                                okText="Yes"
                                cancelText="Cancel"
                            >
                                <FunctionalButton
                                    variant="info ml-2"
                                    value="Export selected"
                                    disabled={!isExportAvailable}
                                />
                            </Popconfirm>

                            {/* title="Will appears only on drafts with status `Completed`." */}
                        </React.Fragment>
                    : null}
                </div>
            </div>
        );
    }
}

Buttons.propTypes = {
    handleClickDelete: PropTypes.func.isRequired,
    handleClickInactivate: PropTypes.func.isRequired,
    handleClickExport: PropTypes.func.isRequired,
    showDetailsButtons: PropTypes.bool.isRequired,
    showNewDraftButton: PropTypes.bool.isRequired,
    availableExport: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    auth: state.auth,
});

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(Buttons);
